export const ACTION_OPTION = {
  UNPUBLISH: {
    key: 'unpublish',
    label: 'Unpublish selected',
  },
  DUPLICATE: {
    key: 'duplicate',
    label: 'Duplicate selected',
  },
  DELETE: {
    key: 'delete',
    label: 'Delete selected',
    disabled: false,
  },
};

export const ACTION_OPTIONS = Object.values(ACTION_OPTION);
